// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17H4s","clinicsSelect":"styles_clinicsSelect__2CvNh"};